import { Component, OnInit } from "@angular/core";
import { IonicModule, NavController, NavParams } from "@ionic/angular";
import { ModalController } from "@ionic/angular/standalone";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { EventoProvider } from "src/app/services/evento/evento";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { Browser } from "@capacitor/browser";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-documentos",
  templateUrl: "./documentos.page.html",
  styleUrls: ["./documentos.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class DocumentosPage implements OnInit {
  idPessoa: string;
  idInstituicao: any;
  documentosList: any;
  certificadosList: any;
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    public pessoaProvider: PessoaProvider,
    public eventoProvider: EventoProvider,
    public modalCtrl: ModalController,
    public userProvider: UserProvider
  ) {
    this.idPessoa = this.navParams.get("idPessoa");
    this.idInstituicao = this.navParams.get("idIntituicao")
      ? this.navParams.get("idIntituicao")
      : this.userProvider.idInstituicao;
    this.getDocumentos();
  }

  ngOnInit() {}

  getDocumentos() {
    this.pessoaProvider.getDocumentos(this.idPessoa).subscribe((data: any) => {
      if (data) {
        this.documentosList = data.filter((documentos: any) => !documentos.tema);
        this.certificadosList = data.filter((certificado: any) => certificado.tema);
      }
      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    });
  }

  openPdf(file: string) {
    const url = `${environment.DOWNLOAD_URL}/${file}`;
    Browser.open({ url });
  }

  getEventosCertificados() {
    this.eventoProvider.getEventosEnsinosCertificados(this.idPessoa).subscribe((data) => {
      if (data) {
        const certificadosEventos = this.documentosList.filter((document: any) => document.idEvento);
        this.certificadosList = [...certificadosEventos, ...data];
      }
    });
  }

  openPdfEvento(certificado: any) {
    certificado.idPessoa = this.idPessoa;
    certificado.idInstituicao = this.idInstituicao;

    const url =
      environment.PORTAL_URL +
      "/frontend/evento-api/render-certificado-evento?certificado=" +
      this.eventoProvider.encodeObjToUrl(certificado);

    Browser.open({ url });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
